import { HarnessOutline } from "./harnessRailItems";
import { HarnessRailItemView } from "./HarnessRailItemView";

/**
 * A nested outline (an agent's own activity), rendered flat: every segment
 * open, narration as quiet header lines, the same item renderers one level
 * deeper. No live line and no collapse — the parent row is the disclosure.
 */
export function HarnessOutlineView({
  outline,
  depth,
}: {
  outline: HarnessOutline;
  depth: number;
}) {
  return (
    <div className="relative py-1">
      <span
        aria-hidden
        className="pointer-events-none absolute bottom-3 left-[27px] top-3 w-px bg-n-20"
      />
      {outline.segments.map((segment) => (
        <div key={segment.key}>
          {segment.header && (
            <div className="flex items-start gap-2 px-4 py-1.5">
              <span className="relative z-[1] mt-1 flex size-6 shrink-0 items-center justify-center bg-background">
                <span className="size-1.5 rounded-full bg-n-40" />
              </span>
              <span className="min-w-0 flex-1 line-clamp-2 font-sans text-xs text-n-70 text-pretty">
                {segment.header.content}
              </span>
            </div>
          )}
          {segment.items.map((item) => (
            <HarnessRailItemView
              key={item.key}
              item={item}
              live={false}
              depth={depth}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
